import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';

export const DEFAULT_TIME_RANGE = {
  kind: TimeRangeKind.RELATIVE_TIME_RANGE,
  relative: { lastNumDays: 7 },
};
